﻿export class SearchOverlay {

    public static clickHandler($: JQueryStatic): void {

        $('.search-overlay-trigger, .main-header__search-icon-mob').on('click', function () {

            $('.quick-search-overlay').addClass('open');
            $('body').addClass('nav-open');

        });

        $('.quick-search-overlay__close-btn').on('click', function () {

            $('.quick-search-overlay').removeClass('open');

            if (!$('.burger-menu__container').is('.burger-open')) {
                $('body').removeClass('nav-open');
            }
        });
    }

    public static addSearchLabel($: JQueryStatic): void {

       $('.quick-search-overlay').find('.attrax-search-widget__search-button').prepend('<span>Search</span>');
    }

}